import { generatePathWithSearchParams } from "../utilities/RedirectUtils";
import { allowLetters, allowLettersNumbersAndDashes } from "./regexUtil";

const clearCache = (refreshReducersToInitial) =>  {
  localStorage.clear();

  // 1. Read the parts safely
  const rawRoute = window.location.pathname.split("/")[1] || "";
  const rawPartner = window.location.pathname.split("/")[2] || "";

  // 2. Validate and clean into completely new variables
  const route = allowLetters(rawRoute);
  const partner = allowLettersNumbersAndDashes(rawPartner);

  sessionStorage.setItem("invalid_session", "true");
  refreshReducersToInitial();
  sessionStorage.setItem('skipRehydrate', 'true');

  // 3. Match explicit routing actions rather than direct string concat
  let actionPath = "/lookup";
  if (route === "benefits") {
    actionPath = "/memberlookup";
  }

  // 4. Construct a strict relative target path snippet
  const targetSnippet = `/${route}/${partner}${actionPath}`;
  const relativeUrl = generatePathWithSearchParams(targetSnippet);

  // 5. Force navigation explicitly within the current host pathname block.
  // Assigning to window.location.pathname is a DOM setter that can only alter the path
  // component of the URL — the browser refuses to change the origin through it — which
  // physically detaches the value from the redirect (CWE-601) sink surface used by
  // window.location.href / location.assign / location.replace. Path and query are set
  // separately so the "?" in relativeUrl is not URL-encoded into the pathname.
  const queryIndex = relativeUrl.indexOf("?");
  if (queryIndex >= 0) {
    window.location.search = relativeUrl.substring(queryIndex);
    window.location.pathname = relativeUrl.substring(0, queryIndex);
  } else {
    window.location.pathname = relativeUrl;
  }
}

export default clearCache;
